export default __webpack_public_path__ + "static/image-40-64fbbed6fbdb0fe861a5c2c684b2771a.jpg";